import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../utils/hooks";
import { closeErrorAlert } from "../store/Slices/ErrorAlertSlice";

export default function ErrorAlertModal() {
  const dispatch = useAppDispatch();
  const { open, title, message, details } = useAppSelector(
    (state) => state.ErrorAlert,
  );
  const [copied, setCopied] = useState(false);

  async function copyDetails() {
    const text = [title, message, details].filter(Boolean).join("\n\n");
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      // fallback
      const ta = document.createElement("textarea");
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    }
  }

  return (
    <Dialog
      open={open}
      onClose={() => dispatch(closeErrorAlert())}
      className="relative z-[200]"
    >
      <div className="fixed inset-0 bg-black/40" aria-hidden />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="w-full max-w-md rounded-2xl border border-borderColor bg-modalBg p-5 shadow-xl">
          <DialogTitle className="text-lg font-semibold text-darkText">
            {title || "Error"}
          </DialogTitle>
          <p className="mt-2 text-sm text-darkText/90">{message}</p>
          {details && (
            <pre className="mt-3 max-h-48 overflow-auto rounded-lg bg-secondary p-3 text-xs text-lightText">
              {details}
            </pre>
          )}
          <div className="mt-5 flex justify-end gap-2">
            <button
              type="button"
              onClick={copyDetails}
              className="rounded-lg border border-borderColor px-4 py-2 text-sm text-darkText transition hover:bg-dropdownOptionHover"
            >
              {copied ? "Copied" : "Copy"}
            </button>
            <button
              type="button"
              onClick={() => dispatch(closeErrorAlert())}
              className="rounded-lg bg-themeColor px-4 py-2 text-sm font-medium text-themeTextColor"
            >
              OK
            </button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
